<template>
  <div class="more-action">
    <van-cell-group v-if='!isReport'>
        <van-cell title="不感兴趣" @click="$emit('dislike')"/>
        <van-cell title="举报垃圾内容" @click="isReport=true" is-link />
        <van-cell title="拉黑作者"/>
    </van-cell-group>

    <van-cell-group v-else>
      <van-cell icon="arrow-left" @click="isReport=false">返回</van-cell>
      <van-cell v-for="item in reportList" :key="item.value" @click="$emit('report', item.value)">{{item.label}}</van-cell>
     </van-cell-group>
  </div>
</template>

<script>
import reportList from '@/constant/report.js'
export default {
  name: 'more',
  data () {
    return {
      isReport: false,
      reportList
    }
  },
  props: ['showmore']

}
</script>

<style lang='scss' scoped>

.more-action {
  border-radius: 4px;
}

</style>
